import { IWorkflowType } from "@/interfaces/workflow-type.interface";
import { WorkflowMessages } from "@/messages/workflow/workflow.messages";
import { WorkflowSaveDialogMessages } from "@/messages/workflow/workflow-save-dialog.messages";
import { WorkflowTypes } from "@/types/workflow.types";

export function workflowTypeOptionLabel(
  type: Pick<IWorkflowType, "id" | "name" | "description">
): string {
  const description = type.description?.trim();
  if (description) return description;
  const name = type.name?.trim();
  if (name) return name;
  return String(type.id);
}

/** Opções só a partir do GET v1/workflowtype: value = id, label = description (fallback name). */
export function WORKFLOW_TYPE_SELECT_OPTIONS(workflowTypes: IWorkflowType[] | undefined) {
  if (!workflowTypes?.length) return [];
  return [...workflowTypes]
    .sort((a, b) => a.id - b.id)
    .map((type) => ({
      value: type.id,
      label: workflowTypeOptionLabel(type),
    }));
}

export function buildWorkflowTypeLabelResolver(
  workflowTypes: IWorkflowType[] | undefined,
  messages: WorkflowMessages
): (workflowTypeId: number) => string {
  return (workflowTypeId: number) => {
    const match = workflowTypes?.find((t) => t.id === workflowTypeId);
    if (match) return workflowTypeOptionLabel(match);
    switch (workflowTypeId) {
      case WorkflowTypes.StartFlow:
        return messages.startFlow;
      case WorkflowTypes.OrderStatus:
        return messages.orderStatus;
      case WorkflowTypes.Shopping:
        return messages.shopping;
      default:
        return String(workflowTypeId);
    }
  };
}

/** Modal “Tipo do agente”: mesma lista do backoffice + opção “nenhum”. */
export function buildActivationWorkflowTypeSelectOptions(
  messages: WorkflowSaveDialogMessages,
  workflowTypes: IWorkflowType[] | undefined
): { value: number; label: string; disabled?: boolean }[] {
  const fromApi = WORKFLOW_TYPE_SELECT_OPTIONS(workflowTypes);
  return [{ value: -1, label: messages.noWorkflowOption }, ...fromApi];
}
